import * as R from "ramda";
import * as React from "react";
import { RootState } from "../../store";

export type KeyboardHandler = (ev: KeyboardEvent) => void;

export const KeyCode_Enter = "Enter";

export const getKeyCode = (ev: KeyboardEvent | React.KeyboardEvent): string => {
    if (R.isNil(ev.key)) {
        return ev.code;
    }

    return ev.key;
}

export const dialogIsShown = (state: RootState) => (
    state.debugLog.showDebugLog === true ||
    state.history.removeHistoryDialogVisible === true ||
    state.privacyPolicy.privacyPolicyDialogVisible === true ||
    state.consent.consentDialogIsVisible === true ||
    state.error.lastError !== null
);